import Vue from 'vue'
import App from './App'
import router from './router'
import store from './modules/store'
import i18n from './modules/i18n'
import FairApi from './modules/api'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowLeft,
  faPlus,
  faBuilding,
  faBars,
  faSearch,
  faTrash,
  faTimes,
  faUserCircle,
  faGlobe,
  faPencilAlt,
  faMapMarker,
  faCaretLeft,
  faCaretRight,
  faHome,
  faCopy,
  faInfoCircle,
  faFutbol,
  faHeart,
  faSchool,
  faTree,
  faHandHoldingHeart,
  faHands,
  faGlobeAfrica,
  faBasketballBall,
  faHandHolding

} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueReCaptcha } from 'vue-recaptcha-v3'
library.add(
    faArrowLeft,
    faPlus,
    faBuilding,
    faBars,
    faSearch,
    faTrash,
    faTimes,
    faUserCircle,
    faGlobe,
    faPencilAlt,
    faMapMarker,
    faCaretLeft,
    faCaretRight,
    faHome,
    faCopy,
    faInfoCircle,
    faFutbol,
    faHeart,
    faSchool,
    faTree,
    faHandHoldingHeart,
    faHands,
    faGlobeAfrica,
    faBasketballBall,
    faHandHolding
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_FAIR_CAPTCHA_SITE_KEY,
});

Vue.config.productionTip = false

FairApi.init(process.env.VUE_APP_FAIR_API);

export const app = new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')

